export const homeCourses = [
  {
    id: 1,
    title: 'Quran Reading Course',
    slug: 'quran-reading-course',
    description: 'ALNoor Tutors is a respected online Quran school. We prepared this course for those who are unfamiliar with Quranic reading. Beginners should start with Noorani Qaida, Rehmani Qaida, Madani Qaida, or Baghdadi Qaida.',
    image: '/courses/reading.jpg',
    badge: 'Popular'
  },
  {
    id: 2,
    title: 'Learn Quran Recitation with Our Online Tajweed Course',
    slug: 'tajweed-course',
    description: 'ALNoor Tutors proudly offers Tajweed course. It guides you proper Quranic pronunciation and recitation. It is suitable for both beginners and advanced students. Learning Tajweed is very important for all Muslims who want to master Quran recitation.',
    image: '/courses/tajweed.jpg'
  },
  {
    id: 3,
    title: 'Memorize the Quran with Our Online Course',
    slug: 'quran-memorization-course',
    description: 'Memorizing the Quran is a great blessing. Our ALNoor Tutors provides an extensive Quran memorization course. We welcome students of all ages who wish to become Hafiz-e-Quran. Start with free trial and learn Quran online at your own home.',
    image: '/courses/memorization.jpg',
    badge: 'Featured'
  },
  {
    id: 4,
    title: 'Ijazah Course: Deep Understanding of Quran & Hadith',
    slug: 'ijazah-course',
    description: 'Our ijazah course covers both Hadith and Quran deeply understanding. You\'ll learn about Hadith authenticity, chains of narration, and their explanations. We additionally educate students about the Quran with translation and detailed understanding.',
    image: '/courses/ijazah.jpg'
  },
  {
    id: 5,
    title: 'Learn the Art of Quranic Recitation with Our Ten Qirat Course',
    slug: 'ten-qirat-course',
    description: 'Our Ten Qirat Course is an advanced level program. Students first master Tajweed and proper pronunciation of letters. The course teaches where to pause during recitation & where to continue. Our ALNoor Tutors offers training in all ten types of Qirat.',
    image: '/courses/ten-qirat.jpg'
  },
  {
    id: 6,
    title: 'Understanding the Quran with Our Tafseer Course',
    slug: 'tafseer-course',
    description: 'Tafseer helps us understand the Quran\'s meanings, words, commands, and the circumstances of its revelation. Through our Tafseer course, you will understand Quranic verses better. Anyone can join this course, regardless of their current knowledge level.',
    image: '/courses/tafseer.jpg'
  },
  {
    id: 7,
    title: 'Arabic Language Course',
    slug: 'arabic-language-course',
    description: 'We are now offering an extensive Arabic language course. People have different reasons for learning Arabic. Some want to visit Arab countries or do business. Some wish to understand the Quran and Hadith more deeply. Our Arabic course is beneficial to everyone.',
    image: '/courses/arabic.jpg'
  },
  {
    id: 8,
    title: 'Islamic Studies Course',
    slug: 'islamic-studies-course',
    description: 'Every Muslim needs to know the basic principles of Islam. Our Islamic Studies course is suitable for everyone – children, adults, and seniors. We will teach the fundamentals of Islamic worship, history, and the life of Prophet Muhammad ﷺ.',
    image: '/courses/islamic-studies.jpg'
  },
  {
    id: 9,
    title: 'Dua Course (Islamic Supplication)',
    slug: 'dua-course',
    description: 'Learn about the various forms of Duas, their meanings, and the etiquette of praying to Allah. Our experienced instructors will guide you through Dua\'s spiritual and practical aspects. Dua is a special way to talk to Allah - a heartfelt prayer.',
    image: '/courses/dua.jpg'
  }
];

export const freeResources = [
  { id: 1, title: 'Zakat Calculator', icon: '🕌', path: '#' },
  { id: 2, title: 'Quran Para by Para', icon: '📖', path: '#' },
  { id: 3, title: 'Quran with Translation', icon: '📖', path: '#' },
  { id: 4, title: 'Noorani Qaida (PDF)', icon: '📘', path: '#' },
  { id: 5, title: 'Madani Qaida (PDF)', icon: '📘', path: '#' },
  { id: 6, title: 'Rehmani Qaida (PDF)', icon: '📘', path: '#' },
  { id: 7, title: 'Baghdadi Qaida (PDF)', icon: '📘', path: '#' }
];

export const keyFeatures = [
  {
    id: 1,
    title: 'Learn Quran Online Easily With Flexible Schedule',
    description: 'As you know that time is extremely valuable, & managing it in our busy life can be not easy. That is why we provide a flexible class schedule, which is allowing you to take lessons at any time anywhere. Our classes are available 24/7 for professionals, parents, & students.',
    icon: 'schedule'
  },
  {
    id: 2,
    title: 'Personalized Learning',
    description: 'Our one-to-one classes certify that every student gets the teacher\'s full attention. This strategy makes it very easier to learn more in less time. Our all teachers provide individual classes, allowing students to learn at their own pace.',
    icon: 'personalized'
  },
  {
    id: 3,
    title: 'Try Free Before You Start',
    description: 'We offer free trial classes to help you get started easily. Select a teacher, book your trial, and see how we teach the Quran to kids and adults. Book your free trial today and enjoy your first class!',
    icon: 'trial'
  },
  {
    id: 4,
    title: 'Choose Your Teacher',
    description: 'Most parents prefer female teachers for their kids. At Quran school, we provide both male & female tutors. So you can choose the teacher that suits your needs. All our tutors have detailed profiles to help you make the right choice.',
    icon: 'teacher'
  },
  {
    id: 5,
    title: 'Learn Quran Online in Your Own Language',
    description: 'Muslims live all over the world, & each country having its own language. ALNoor Tutors offers multilingual teachers. They teach in your native language - English, Urdu, Hindi, Pashto, & Arabic.',
    icon: 'language'
  },
  {
    id: 6,
    title: 'Anywhere, Any Device',
    description: 'Now learn Quran online is very easy. You just keep a high-speed internet connection & a mobile or laptop. With our flexible schedule, you can learn Quran anytime and from anywhere.',
    icon: 'device'
  }
];

export const stats = [
  { value: '24+', label: 'Years of Experience' },
  { value: '500+', label: 'Qualified Teachers' },
  { value: '3000+', label: 'Satisfied Students' },
  { value: '10,000+', label: 'Teaching Hours' }
];

export const steps = [
  {
    step: 1,
    title: 'Fill Out the Free Trial Form',
    description: 'Start your journey by filling out our free trial form. This form allows our support team to reach out to you and confirm the appointment you\'ve selected for your complimentary trial session.',
    cta: 'BOOK FREE TRIAL'
  },
  {
    step: 2,
    title: 'Confirm Your Appointment',
    description: 'Once you\'ve submitted the form, an assigned tutor will reach out to you within an hour via email, phone call, or WhatsApp to confirm the appointment and provide further details.',
    cta: null
  },
  {
    step: 3,
    title: 'Download the Meeting App',
    description: 'To start your online Quran classes at the scheduled time, download either Zoom or Microsoft Teams. Your tutor will provide the Meeting ID or Room Link upon confirmation.',
    cta: null
  }
];

export const faqs = [
  {
    q: 'What is the Quran Academy?',
    a: 'ALNoor Tutors is an online platform dedicated to teaching the Quran to students of all ages. ALNoor Tutors offers personalized lessons with qualified instructors to help you learn Quran online from the comfort of your home.'
  },
  {
    q: 'How to Learn Quran Online?',
    a: 'You can learn Quran online by enrolling in one of our courses through our website. ALNoor Tutors delivers live one-on-one sessions, interactive lessons, and a flexible schedule to meet your needs.'
  },
  {
    q: 'What courses are offered?',
    a: 'ALNoor Tutors offers lots of courses, including Quran recitation, Tajweed (proper pronunciation), Quran memorization (Hifz), and understanding the Quran\'s meanings. We fulfill different levels, from beginners to advanced learners.'
  },
  {
    q: 'Are Instructors Qualified?',
    a: 'Yes, all our instructors are highly qualified and experienced in teaching the Quran. They are also certified and proficient in Tajweed and Quranic studies, ensuring that you receive the best education when you learn Quran online with us.'
  },
  {
    q: 'What Age Groups Are Taught?',
    a: 'ALNoor Tutors caters to all age groups, from children to adults. We offer tailored lessons to suit the learning pace and style of each student. This makes learning the Quran online easy for everyone.'
  },
  {
    q: 'Can I schedule my lessons?',
    a: 'Absolutely! ALNoor Tutors offers flexible scheduling options. You can choose the time and frequency of your lessons based on your convenience, making it easier to incorporate learning Quran into your busy schedule.'
  },
  {
    q: 'Is There a Trial Period?',
    a: 'Yes, we offer a free trial period for new students. This allows you to experience our teaching methods and see the benefits of ALNoor Tutors before committing to a regular schedule.'
  },
  {
    q: 'How do I get started?',
    a: 'To get started, simply visit our website, fill out the registration form, then choose the course you want to learn. Our team will contact you to arrange your first lesson and help you start your learn Quran online journey.'
  }
];
